"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'question.type.text': 'Testo',
    'question.type.textarea': 'Area di testo',
    'question.type.select': 'Seleziona',
    'question.type.radio': 'Radio',
    'question.type.checkbox': 'Casella di controllo',
    'question.type.number': 'Numero',
    'question.type.email': 'Email',
    'question.type.url': 'URL',
    'question.type.date': 'Data',
};
